export default __webpack_public_path__ + "static/media/raxi_logo.4e51d530.png";